<div class="stepper-container">
  <div class="custom-stepper" [style.max-width]="maxWidth">
    <ng-container *ngFor="let step of steps; let i = index">
      <div 
        class="step" 
        [class.active]="isStepActive(i)" 
        [class.completed]="isStepCompleted(i)"
        [class.locked]="isStepLocked(i)"
        [class.clickable]="step.isClickable"
        (click)="onStepClick(i, step)"
      >
        <div class="circle" [class.lock]="shouldShowLockIcon(i)">
          <span *ngIf="!shouldShowLockIcon(i)">{{ step.number || (i + 1) }}</span>
          <i *ngIf="shouldShowLockIcon(i)" class="pi pi-lock"></i>
          <i *ngIf="step.icon && !shouldShowLockIcon(i)" [class]="step.icon"></i>
        </div>
        <div class="label">{{ step.label }}</div>
      </div>

      <!-- Connector - only show if not the last step -->
      <div 
        *ngIf="i < steps.length - 1"
        class="connector" 
        [class.completed]="isStepCompleted(i)"
      ></div>
    </ng-container>
  </div>

  <div *ngIf="showProgress" class="progress-container">
    <span class="progress-text">{{ progressText }}</span>
    <div class="progress-bar">
      <div 
        class="progress" 
        [style.width.%]="progressValue || getProgressPercentage()"
      ></div>
    </div>
    <span class="progress-percentage">{{ progressValue || getProgressPercentage() }}%</span>
  </div>
</div>